export const SpaceVertical = ({ size }: { size?: number }) => {
  return <div style={{ marginTop: size ? size : 10 }}></div>
}

export const SpaceHorizontal = ({ size }: { size?: number }) => {
  return <div style={{ marginRight: size ? size : 10 }}></div>
}
